module.exports = __webpack_public_path__ + "static/media/dwg.f2391ec0.svg";